import { isBlockFact } from '@epilot/journey-logic-commons/src/next/references'
import type { JumpToStepLogic } from '@epilot/journey-logic-commons/src/types/next'
import {
  AVAILABILITY_CHECK_FUNCTIONS,
  LOGIC_ACTION
} from '@epilot/journey-logic-commons/src/types/next'

import { HIGH_PRIORITY } from '../constants'
import { Executor } from '../executor'
import type { JumpToStepEvent, LogicPriority, RuntimeContext } from '../types'

export class JumpToStepExecutor extends Executor {
  constructor() {
    super(LOGIC_ACTION.JUMP_TO_STEP)
  }

  priority(logic: JumpToStepLogic): LogicPriority {
    // expects a single group & clause to exist
    const functionName = logic.conditions[0]?.[0]?.functionName

    // high priority logics are evaluated first
    switch (functionName) {
      case AVAILABILITY_CHECK_FUNCTIONS.AVAILABILITY_CHECK:
        return HIGH_PRIORITY + 2
      case AVAILABILITY_CHECK_FUNCTIONS.PRODUCT_AVAILABILITY_CHECK:
        return HIGH_PRIORITY + 1
      default:
        return HIGH_PRIORITY
    }
  }

  /**
   * TODO: unit test
   */
  event(
    logic: JumpToStepLogic,
    context?: RuntimeContext
  ): JumpToStepEvent | undefined {
    const matchesCurrentStep = logic.conditions.some((group) =>
      group.some((condition) => {
        if (!isBlockFact(condition.fact)) return true

        const refBlock = context?.blockGetter(condition.fact.referenceId)

        if (!refBlock) return false

        const refStep = context?.stepGetter(refBlock.stepId)

        return refStep?.id === context?.currentStepId
      })
    )

    if (!matchesCurrentStep) return undefined

    return {
      source: logic.id,
      action: LOGIC_ACTION.JUMP_TO_STEP,
      details: {
        targetStep: logic.settings.targetStep
      }
    }
  }
}
